import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';   // ✅ required for ngModel
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { VendorRegistrationComponent } from './vendor-registration/vendorregistration.component';
import { EmployeeRegistrationComponent } from './employee-registration/employee-registration.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonToggleModule,
    VendorRegistrationComponent,
    EmployeeRegistrationComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule
  ],
})
export class RegistrationComponent {
  userType: 'vendor' | 'employee' = 'vendor';
  ngOnInit() {
    localStorage.clear();    
    sessionStorage.clear();
  }
}
